export const dev = {
    production: false,
    SEO_ENABLED: false,
    AUTH_API_URL: 'https://dev-api-auth-seech.azurewebsites.net/api/',
    AUTH_WEB_URL: 'https://dev-auth.seech.com',
    BASE_WEB_URL: 'https://dev.seech.app',
    PAYMENT_WEB_URL: 'https://dev-payment.seech.com',
    PAYMENT_API_URL: 'https://dev-api-payment-seech.azurewebsites.net',
    ACCOUNT_WEB_URL: 'https://dev-account.seech.com',
    BASE_API_URL: 'https://dev-api-spectrum.azurewebsites.net',
    CLIENT_ID: '24A75F18-A62C-4F31-983D-60D156ADB510',
    GOOGLE_API_KEY: 'AIzaSyCR9vRtCUFO7Wbne2xG8-UMNxcLlxglNjE',
    GOOGLE_ANALYTICS_ID: 'G-MZ72MGBS5Q',
    SHARED_CDN_URL: 'https://dev-cdn.seech.app/shared',
    GLOBAL_CDN_URL: 'https://dev-cdn.seech.com/seech',
    STRIPE_PUBLIC_KEY: 'pk_test_51SAfwCII5hq1gt82EyrhpIaJrqVwkczMrQV5C4My85ttvjEkNOWkNbjyf1GIHvRTA2MumOCfe8ivlWWqqWu1ZudA005n8Q5KKX'
};
